module.exports = __webpack_public_path__ + "img/Hoffenheim.edc04691.png";